import React, { useContext, useEffect, useState } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import Footer from "./footer";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { _colorExp } from "gsap/gsap-core";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";





function Gumastalicense() {

   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email_address: parsedUser.email || "",
          user_phone_number: parsedUser.mobile || "",
          user_city: parsedUser.city || "",
        }));
      }
    }, []);

   const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };

   const[newData,setNewData]=useState({user_name:'',user_email_address:'',user_phone_number:'',user_city:'',user_employe:''})
      const [errors, setErrors] = useState({});

         const { services, loading, error } = useContext(ServicesContext);  
         if (loading) {
            return <div>Loading...</div>;  // Show loading state while fetching data
        }
      
        if (error) {
             return <div>{error}</div> // Show error state if there was an issue fetching data
        }
         const service = services.find(s => s.service_id === 11);
      
         const validateForm = () => {
            const newErrors = {};
      
            // Name validation
            if (!newData.user_name.trim()) {
               newErrors.user_name = 'Name is required.';
            }   else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
               newErrors.user_name = '*Name should only contain letters and spaces.';
             }
      
            // Email validation
            if (!newData.user_email_address.trim()) {
               newErrors.user_email_address = 'Email is required.';
            } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
               newErrors.user_email_address = 'Enter a valid email address.';
            }
      
            // // Phone number validation
            // if (newData.user_phone_number && !/^\d{10}$/.test(newData.user_phone_number)) {
            //    newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
            // }

            if (!newData.user_phone_number.trim()) {
               newErrors.user_phone_number = 'number is required.';
             } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
               newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
             }
      
      
            // Category validation
            if (!newData.user_city) {
               newErrors.user_city = 'Please select a city.';
            }
            if (!newData.user_employe) {
               newErrors.user_employe = 'Please select employees.';
            }
      
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0; // Return true if no errors
         };



 const formPutPartenshipdeed = async (e) => {
             e.preventDefault();
                 // ✅ Check if user is logged in
       // if (!token) {
      //     alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //    navigate('/login'); // 👈 Use this if you're using React Router
      //    return;
      // }
             if (!validateForm()) return;
           
            localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
              
           };


   return (
      <div>


         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <h1 className="sk-text-color">Shop Act License (Gumasta)
</h1>
<p className="pdrl-text">Get Shop Act License (Gumasta) for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt. Fees As per actual Extra)</span></p>
                        <p className="pd-text">Starting a new business? A Shop Act License (Gumasta)
 is mandatory under the Shops and Establishment Act. At Dm2Legal, we simplify the registration process, allowing you to apply easily from the comfort of your home</p>
                        <p className="pd-text">The Shop Act License (Gumasta)
 is a state-level registration required to operate any business in Madhya Pradesh.</p>
                        <p className="pd-text">Entrepreneurs need a Shop Act License (Gumasta)
 to start any type of business in Madhya Pradesh.</p>
                        <div className="banner">
                           <img src="assets/icons/banner.svg" alt="" srcset="" />
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Book Service Now </h3>
                           <p className="pdrl-text">at Rs.{service?.price}/- Only<span><br/>(Govt. Fees As per actual Extra)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                 <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Email Address<span className="red">*</span></label> {errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Contact Number<span className="red">*</span></label> {errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>

                                    <div className="col-12">
                                    <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                    <div className="space10"></div>
                                    <div className="col-12">
                                    <label for="" className="dropdown-text">Employees<span className="red">*</span></label>  {errors.user_employe && <p className="error-text">{errors.user_employe}</p>}
                                       <div className="niceSelect">
                                       <select className="wide" onChange={(e) => setNewData({ ...newData, user_employe: e.target.value })} value={newData.user_employe}>
                                             <option className="formop" data-display="No. of Employees...">No. of Employees</option>
                                             <option value="0 to 3 workers Employed">0 to 3 workers Employed</option>
                                             <option value="More than 3 workers Employed">More than 3 workers Employed</option>
                                          </select>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">

               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>


               <div className="space40"></div>
               <div className="row">
                  <div className="col-lg-12">
                     <p className="pd-text">Governed by the Madhya Pradesh Shops and Establishment Act, the Shop Act License (Gumasta)
 allows businesses to operate legally within the state. It is essential for business growth, opening a bank account, and securing loans, ensuring a smooth and compliant operation.</p>

                     <p className="pd-text"> A Shop Act License (Gumasta)
 is mandatory for GST registration and is required for all shops and commercial establishments under the Madhya Pradesh Shops and Establishment Act. This Act defines the legal rights and responsibilities of employers and employees, regulating work conditions across businesses like shops, restaurants, hotels, theaters, and entertainment venues.</p>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Benefits of Online Shop Act License (Gumasta)
 Registration with Dm2Legal </h2>
                        <div className="space40"></div>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-9.png" alt="" />
                        </div>
                        <h3>Apply from Anywhere</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-10.png" alt="" />
                        </div>
                        <h3>Expedited Process</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Guidance and Support</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-12.png" alt="" />
                        </div>
                        <h3>Built-in-Checks for error-free Registration</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-13.png" alt="" />
                        </div>
                        <h3>Online Document Management</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-14.png" alt="" />
                        </div>
                        <h3>Best Customer Support System</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-15.png" alt="" />
                        </div>
                        <h3>Real Time Application Tracking</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Competitive Pricing</h3>
                     </div>
                  </div>
                       <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                        <img src="assets/img/icons/service-10.png" alt="" />
                        </div>
                        <h3>Smooth Online Registration Process</h3>
                     </div>
                  </div>
               </div>
             

            </div>
         </div>


         <div className="bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Importance of Timely Shop Act License (Gumasta)
 Renewal</h2>
                     </div>
                  </div>
                  <div className="col-lg-8">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>It is a mandatory legal requirement.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>To prevent severe penalties.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>For uninterrupted and smooth business operations.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>A current Shop Act License (Gumasta)
 enhances the business's reputation.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Obtaining certain permits may require an up-to-date Shop Act License (Gumasta)
.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Failure to comply can lead to legal consequences.</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Documents Required for Shop Act License (Gumasta)
 Registration</h2>
                        <div className="space40"></div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Sole Proprietorship / Individual</h4 >
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Passport size Photograph of the proprietor</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar Card / Voter ID/ Passport</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Pan Card / Driving License</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Premises Photo with Banner</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Board of Trade Name to be licensed</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Nature of your Business / Brand</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Residential address proof</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Registry or Ownership Deed</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental Agreement / NOC from Any Relative</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office adress proof</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4>HUF</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Passport size Photographs of Applicant</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar Card /Voter ID / Passport</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Pan Card / Driving License of Karta</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; HUF Deed Document</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Premises Photo with Banner </li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Board of Trade Name to be licensed</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Nature of your Business / Brand</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Residential address proof</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rent agreement</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office adress proof</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Partnership deed / LLP Agreement</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Passport size Photograph of the proprietor</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar Card / Voter ID/ Passport</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Pan Card / Driving License</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Premises Photo with Banner</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Board of Trade Name to be licensed</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Partnership Deed</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Nature of your Business / Brand</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Residential address proof</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Registry or Ownership Deed </li>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; The name of Partnership firm</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office adress proof</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                 
               </div>
               <div className="row">
                  <div className="col-lg-6 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Society / Trust / Club</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Passport size Photographs of President or Secretary</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar Card /Voter ID / Passport /Pan Card </li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Driving License of President or Secretary</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Premises Photo with Banner </li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Board of Trade Name to be licensed</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Certificate of Registration</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Nature of your Business / Brand</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Residential address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Registry or Ownership Deed </li>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; The name of Partnership firm</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office adress proof</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Private limited / Public limited / One person company</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Passport size Photograph of the proprietor</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar Card / Voter ID/ Passport</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Pan Card / Driving License</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Premises Photo with Banner</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Board of Trade Name to be licensed</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Certificate of Incorporation</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; MOA</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; AOA</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Nature of your Business / Brand</li>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Residential address proof</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Registry or Ownership Deed of Company</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office adress proof</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                     <div className="space20"></div>
                        <h2 className="text-center">Mistakes to Avoid in Shop Act License (Gumasta)
 Registration  </h2>
                        <div className="space20"></div>
                     </div>
                  </div>
                  <div className="col-lg-7">
                     <div className="contact6-list doc-list" >
                        <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Insufficient Documentation</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Inaccurate or incomplete information</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Failure to comply with local registration laws</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Failing to keep track of the Shop Act License (Gumasta)
 renewal dates</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Avoiding inspections conducted by the relevant authority</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Ignoring the rules that change periodically</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Incorrectly classNameifying the business category</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Neglecting to seek expert advice when needed</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-lg-5">
                     <div className="contact6-list doc-list">
                        <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                     </div>
                  </div>
               </div>
               <div className="space30"></div>

               <div className="space20"></div>
            </div>
         </div>

         <div className="service-binifits9 sp0" id="service2" >
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12 text-center">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="aos-init aos-animate">The Process of Online Shop Act License (Gumasta)
 Registration</h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                           <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Book the service and complete the Shop Act License (Gumasta)
 Registration form by providing all the required details.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our experts will verify all the details and documents you have submitted. Additionally, our team will assist you in arranging any required documents.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Once all the submitted documents and information are successfully verified, our experts will proceed with applying for your Shop Act License (Gumasta)
.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>After successfully submitting your Shop Act License (Gumasta)
 registration application, our team of experts will closely monitor its progress.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>Our expert will then get in touch with you to notify you of the successful completion of your Shop Act License (Gumasta)
 registration.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>

                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="bg-white">

         </div>


         <div className="bg-white">

            <div className="container ">


               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                              <div className="space20"></div>


                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: How long is the Shop Act Registration valid?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">The Shop Act Registration is typically valid for 1 year and needs to be renewed annually. However, the validity may vary depending on the state-specific regulations. Regular renewal is essential to maintain compliance with the law. .</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: What are the components of a Shop Act License (Gumasta)?
?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >The Shop Act License (Gumasta) typically includes:
                                       <p className="font-f-3 weight-500"> 1. Shop name and address.</p>
                                       <p className="font-f-3 weight-500"> 2. Owner's details (name, contact information).</p>
                                       <p className="font-f-3 weight-500">3. Nature of the business.</p>
                                       <p className="font-f-3 weight-500">4. Employee details, if applicable.</p>
                                       <p className="font-f-3 weight-500"> 5. Valid registration number issued by the respective local authority.</p>
                                       These components ensure that businesses are legally registered and compliant with local laws.
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: Who needs to obtain a Shop Act License (Gumasta)?
?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500"> Any business or commercial establishment operating in India, including shops, retail outlets, offices, and restaurants, must obtain a Shop Act License (Gumasta). This is applicable to all entities, whether sole proprietors, partnerships, or companies, engaged in trade, manufacturing, or service delivery.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4. Do I require a Gumasta if I want to sell online on Amazon?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">Yes, if you're selling goods online, such as on Amazon, you are still required to obtain a Gumasta (Shop Act License). It is needed to legally operate your business, even if it's an online platform, as it ensures compliance with local business regulations and tax obligations. </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5. If I have two shops or two offices, do I require a Shop Act for each location separately?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, you will need to obtain a separate Shop Act License (Gumasta) for each location if you have two shops or offices. Each establishment must be registered individually with the local authorities to ensure compliance with regulations.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6.What is meant by the establishment for Shop Act registration?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       The term establishment in the context of Shop Act registration refers to any commercial premises or business setup where goods or services are sold or offered. It could include a shop, office, restaurant, factory, or any other trade-related business. The establishment must be registered under the Shop Act to operate legally within the specified locality.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7. How do I have to send my documents?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Dm2Legal accepts documents through our user panel. Rest assured, we have a strict confidentiality policy and will delete the records from our system once the work is completed. You can easily upload your documents in .pdf, .doc, or .jpeg format. </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8. What is the objective of the Shops & Establishments Act?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       The objective of the Shops & Establishments Act is to regulate and ensure the proper functioning of commercial establishments, including shops, offices, and factories. It aims to protect the rights of workers, ensure health and safety standards, define working hours, and maintain orderliness in business operations. The act helps in creating a fair and balanced work environment for both employers and employees.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9: Who needs to register for the Shop Act License?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Anyone who operates a commercial establishment like a shop, office, restaurant, factory, or any other business needs to register for the Shop Act License.                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10. Is a license required for a small shop without any employees under the Worker's Compensation Act?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, Shop Act Registration, also known as Gumasta Registration, is required for any commercial establishment, regardless of size or whether it has employees. This includes self-employed individuals and professionals.
                                       </p>
                                    </div>
                                 </div>

                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

         </div>


         <Testimonials />





         <div className="sp2 last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                      
                        <h2>Why Choose Dm2Legal for Shop Act License (Gumasta)
 Registration? </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="single-service-1.html" >Convenient Registration</a></h4>
                           <p>With the Dm2Legal mobile app or website, users can easily register online by providing their name, email ID, contact number, and the required service. After completing your online registration, our team will get in touch with you to continue the process for your Shop Act License (Gumasta)
 registration.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                           <p>Dm2Legal is one of the leading online platforms in India that can assist you with your Shop Act License (Gumasta)
 registration. No matter where you are, we are ready to serve you online.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Customer Support</a></h4>
                           <p>The Dm2Legal team is renowned for providing exceptional support and assistance to our clients. We not only assist you throughout the Shop Act License (Gumasta)
 registration process but also value your feedback and continue to offer support even after the registration is complete.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>With over 10 years of experience, we are well-versed in the Shop Act License (Gumasta)
 Registration process. By choosing us, you'll benefit from working with skilled experts who will make the registration process smooth and hassle-free.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                           <p>Our team is committed to delivering prompt service without any delays. We understand the importance of your time, so we begin working on your Gumasta registration immediately, ensuring an efficient and effective process.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Services</a></h4>
                           <p>We provide cost-effective services without compromising on quality. With every investment you make in our service, we ensure that both your satisfaction and budget are our top priorities.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />

      </div>

   );
}
export default Gumastalicense;